import { theme } from "antd";
import { tokens } from "./weet-tokens.js";
import { buttonThemeConfig } from "../components/button/theme.config.js";
import { switchThemeConfig } from "../components/switch/theme.config.js";
import { inputThemeConfig } from "../components/input/theme.config.js";
import { inputNumberThemeConfig } from "../components/input-number/theme.config.js";
import zh_CN from "antd/es/locale/zh_CN";
const configProviderProps = {
    wave: {
        disabled: true
    },
    prefixCls: 'weet',
    iconPrefixCls: 'weet-icon',
    locale: zh_CN,
    theme: {
        inherit: false,
        algorithm: theme.defaultAlgorithm,
        cssVar: {
            prefix: 'wc'
        },
        hashed: false,
        token: {
            colorPrimary: tokens.blue600,
            borderRadius: 4,
            colorText: tokens.weetColorTextDefault
        },
        components: {
            Button: buttonThemeConfig.tokens,
            Switch: switchThemeConfig.tokens,
            Input: inputThemeConfig.tokens,
            InputNumber: inputNumberThemeConfig.tokens
        }
    },
    button: buttonThemeConfig.config,
    switch: switchThemeConfig.config,
    input: inputThemeConfig.config,
    inputNumber: inputNumberThemeConfig.config
};
export { configProviderProps };
